import { render, staticRenderFns } from "./create-modal.vue?vue&type=template&id=661aa571&scoped=true"
import script from "./create-modal.vue?vue&type=script&lang=js"
export * from "./create-modal.vue?vue&type=script&lang=js"
import style0 from "./create-modal.vue?vue&type=style&index=0&id=661aa571&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661aa571",
  null
  
)

export default component.exports